import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import type { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { LinkButton } from "../../atoms"

export interface IBackButtonProps {
  text?: string
  onClick?: () => void
}

export function BackButton(props: IBackButtonProps): ReactElement {
  const { text, onClick } = props
  const { t } = useTranslation("general")

  const history = useHistory()

  function handleClick(): void {
    if (onClick) onClick()
    else history.go(-1)
  }

  return (
    <LinkButton onClick={handleClick} className="back-button">
      <ArrowBackIcon />
      {text ? text : t("goBack")}
    </LinkButton>
  )
}
